import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'
import Slider from "react-slick"

import IconSVG from "../../utilities/FrontFunctions/IconSVG"
import { throttle, isMobile } from "../../utilities/FrontFunctions/AoxGlobalFrontFunctions"
import { urlToHost } from "../../utilities/FrontFunctions/AoxFrontFunctions"

import '../../assets/css/0020_objects/0621_obj_carrousel_slider.css'
import '../../assets/css/0020_objects/0830_obj_derniers_ajouts_aside.css'

class ObjDerniersAjoutsAside extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isMobile: isMobile(),
		}
		this.handleWindowResizeMainHeader = this.handleWindowResizeMainHeader.bind(this)
		this.throttleWindowResizeMainHeader = throttle(this.handleWindowResizeMainHeader, 200)
	}
	handleWindowResizeMainHeader() {
		this.setState({
			isMobile: isMobile()
		})
	}

    onSwipe() {
        if (this.slider) {
          	this.slider.innerSlider.clickable = true;
        }
	}

	render() {
        const { datasTrainings } = this.props;

		const sliderRef = slider => {this.slider = slider}
		const settings = {
            className: "obj_carousel_formation obj_carrousel_slider",
            centerMode: true,
			infinite: false,
			slidesToShow: 1,
			swipeToSlide: true,
			onSwipe: this.onSwipe.bind(this),
			centerPadding: "10%",
            dots: true,
            dotsClass: "slider-nav",
            appendDots: dots => (
                <div className="slider-nav" >
                    <ul> {dots} </ul>
                </div>
            ),
            arrows: false,
            speed: 750,
        }

        return (<> {datasTrainings && <>
			<div className="obj_derniers_ajouts_aside">
				<h3 className="t_title">
					<IconSVG icon="clock_twelve_thirty" />
					Derniers ajouts
				</h3>
				
				{ this.state.isMobile &&

				   <div className="ctn_carrousel obj_menu_aside_list">
						<Slider {...settings} ref={sliderRef}>
							{ datasTrainings.slice(0,2).map((datasTraining, index) => (
								<div className="item" key={index}>
									<div className="menu_aside-item">
                                        <a href={urlToHost(datasTraining.Training_Url)}>
											<div className="obj_image">
												<picture className="ctn_image fade-in">
                                                    <img src={urlToHost(datasTraining.Training_Image_Url)} alt={datasTraining.Training_Title} />
												</picture>
											</div>
											<div className="menu_aside_text">
                                                <h3 className="t_title">{datasTraining.Training_Title}</h3>
                                                {/* <p className="t_desc">{FavFormationAsideItem.desc}</p> */}
												<div className="obj_nb-views">
													<IconSVG icon="eye_outline" />
                                                    <span>{datasTraining.Training_NbViews || 0} {(datasTraining.Training_NbViews || 0)<2 ? "vue" : "vues"}</span>
                                                </div>
											</div>
										</a>
									</div>
								</div>
							))}
						</Slider>
					</div>
                  
                }
                
                {!this.state.isMobile &&

                   <ul className="obj_menu_aside_list">
						{ datasTrainings.slice(0,2).map((datasTraining, index) => (
                            <li key={index} className="menu_aside-item">
                                {/* Url relative venant de la DB => doit être absolu*/}
                                <a href={urlToHost(datasTraining.Training_Url)}>
                                    <div className="obj_image">
                                        <picture className="ctn_image fade-in">
                                            <img src={urlToHost(datasTraining.Training_Image_Url)} alt={datasTraining.Training_Title} />
                                        </picture>
                                    </div>
                                    <div className="menu_aside_text">
                                        <h3 className="t_title">{datasTraining.Training_Title}</h3>
                                        {/* <p className="t_desc">{FavFormationAsideItem.desc}</p> */}
                                        <div className="obj_nb-views">
                                            <IconSVG icon="eye_outline" />
                                            <span>{datasTraining.Training_NbViews || 0} {(datasTraining.Training_NbViews || 0)<2 ? "vue" : "vues"}</span>
                                        </div>
                                    </div>
                                </a>
                            </li>
						))}
					</ul>
				
                }
				
			</div>
        </>}</>)
	}
}

export default withTranslation()(withSitecoreContext()(ObjDerniersAjoutsAside));